const slider = new Swiper('.rltm-post-slider', {
	slidesPerView: 1,
	spaceBetween: 16,
	watchSlidesProgress: true,
	loop: true,
	breakpoints: {
		768: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		992: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
	},
	navigation: {
		nextEl: '.rltm-post-slider-button-next',
		prevEl: '.rltm-post-slider-button-prev',
	},
	pagination: {
		el: '.rltm-post-slider-pagination',
		clickable: true,
	},
});
